var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M12.444 1.293c1.719-1.724 4.515-1.724 6.234 0 .834.83 1.293 1.936 1.293 3.114 0 1.18-.46 2.286-1.293 3.12L7.248 18.952c-.106.11-.255.17-.404.17-.15 0-.298-.064-.404-.17l-4.605-4.604-.591 4.374 3.03-.408c.315-.043.604.179.646.493.043.315-.178.605-.493.647l-3.779.51c-.025.005-.05.005-.076.005-.15 0-.298-.064-.405-.17-.123-.123-.187-.302-.161-.48l.846-6.273c.017-.124.073-.239.162-.328l11.43-11.425zm2.14 3.323l-1.919-1.92-10.43 10.43 1.92 1.92 10.43-10.43zm-7.736 13.12l-1.876-1.878 10.43-10.43 1.876 1.877-10.43 10.43zm6.638-15.843l4.592 4.591c.48-.583.745-1.306.745-2.077 0-.872-.337-1.693-.954-2.306s-1.434-.953-2.306-.953c-.766 0-1.494.264-2.077.745z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7fc71eb32dec8985cf2b3163aeb9a7a6.svg";
export { ForwardRef as ReactComponent };